import { FunctionComponent } from 'react';

import { Option } from 'types/options';

import { getOptionValue } from 'utils/option';

import ExclamationIcon from 'theme/icons/info.svg';

import Select from 'components/layout/forms/Select';
import Tooltip from 'components/layout/Tooltip/component';
import ActiveFiltersBar from 'components/modules/public/layout/jobs/ActiveFiltersBar';
import { FitlersSort } from 'components/modules/public/pages/Jobs/types';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutJobsResultsHeader: FunctionComponent<Props> = ({
    translations,

    jobCategories,
    jobAgreements,
    jobModes,
    jobExperiences,
    jobLanguages,
    jobTimes,

    searchParams,
    onChangeSearchParam,
    onClearFilters,
    onClearAll,

    onSearch,
    collection,
}) => {
    const getOfferWord = (count: number): string => {
        const lastTwoDigits = count % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return 'ofert';

        const lastDigit = count % 10;

        if (lastDigit === 1) return 'ofertę';
        if (lastDigit >= 2 && lastDigit <= 4) return 'oferty';

        return 'ofert';
    };

    const offerCount = Number(collection?.meta?.total ?? collection?.elements?.length ?? 0);
    const phrase = searchParams?.name?.getValue?.();

    const options = [
        ...(phrase ? [{
            value: FitlersSort.Relevant,
            label: translations.filters.sort.options.relevant,
        }] : []),
        {
            value: FitlersSort.Newest,
            label: translations.filters.sort.options.newest,
        }, {
            value: FitlersSort.Last3Days,
            label: translations.filters.sort.options.last3Days,
        }, {
            value: FitlersSort.Last7Days,
            label: translations.filters.sort.options.last7Days,
        }, {
            value: FitlersSort.Salary,
            label: translations.filters.sort.options.salary,
        },
    ];

    if (collection.elements.length == 0) return null;

    const cityValue = searchParams?.city?.getValue?.();
    const city = typeof cityValue === 'string' ? cityValue : cityValue?.name;
    const offerWord = getOfferWord(offerCount);

    const headline = (() => {
        const base = `Znaleziono ${offerCount} ${offerWord}`;

        if (phrase && city) return `${base} dla "${phrase}" w ${city}`;
        if (phrase) return `${base} dla "${phrase}"`;
        if (city) return `${base} w <b>${city}</b>`;

        return base;
    })();

    return (
        <StyledComponent className="public-layout-jobs-results-header">
            <ActiveFiltersBar
                jobCategories={jobCategories}
                jobAgreements={jobAgreements}
                jobModes={jobModes}
                jobExperiences={jobExperiences}
                jobLanguages={jobLanguages}
                jobTimes={jobTimes}

                searchParams={searchParams}
                onChangeSearchParam={onChangeSearchParam}
                onClearFilters={onClearFilters}
                onClearAll={onClearAll}
            />
            <div className="title-row">
                <div className="block-title">
                    <div
                        className="title"
                        dangerouslySetInnerHTML={{ __html: headline }}
                    />
                    {collection?.meta && collection.elements.length > 0 && (
                        <div className="page-info">
                            {`Strona ${collection.meta.currentPage} z ${collection.meta.lastPage}`}
                        </div>
                    )}
                </div>

                <div className="block-filters">
                    <div className="sort-label">
                        <div
                            className="title"
                            dangerouslySetInnerHTML={{ __html: translations?.filters?.sort?.label }}
                        />
                        <Tooltip
                            name='tooltip-sort'
                            text={translations?.filters?.sort?.tooltip}

                        >
                            <img
                                src={ExclamationIcon}
                                alt="Więcej informacji"
                                width="24"
                                height="24"
                            />
                        </Tooltip>
                    </div>
                    <div className="filter">
                        <Select
                            inputProps={{ isClearable: false }}
                            name="newest"
                            onChange={(option: Option<FitlersSort>) => {
                                onChangeSearchParam('sort', option.value);
                            }}
                            value={{
                                label: options.find(option => option.value == searchParams.sort.getValue())?.label,
                                value: searchParams.sort.getValue(),
                            }}

                            options={options}
                        />
                    </div>
                </div>
            </div>
        </StyledComponent>
    );
};

export default PublicLayoutJobsResultsHeader;